// RelativeDateValueEditor.jsx

import React from 'react';

// Utilities
import {
  RELATIVE_CALENDAR_UNITS,
  RELATIVE_DATE_UNITS,
  normalizeCalendarUnit,
  normalizeRelativeUnit,
} from '../../../utils/automationConditionFilters';

// CSS
import './RelativeDateValueEditor.css';

// Components
import SelectInput from 'components/selectinput/SelectInput';

/**
 * RelativeDateValueEditor
 *
 * Renders unit/value controls for relative temporal condition operators.
 *
 * @param {object} theme - Theme object used for dynamic styling.
 * @param {object} literalValue - Current literal value for relative temporal operators.
 * @param {boolean} requiresRelativeValue - Whether a numeric value input is required.
 * @param {boolean} requiresRelativeUnit - Whether a calendar/date unit selector is required.
 * @param {function} onRelativeValueChange - Updates the relative numeric value.
 * @param {function} onRelativeUnitChange - Updates the relative unit.
 *
 * @returns {ReactNode} The rendered relative date editor.
 */
const RelativeDateValueEditor = React.memo(({
  theme,
  literalValue,
  requiresRelativeValue,
  requiresRelativeUnit,
  onRelativeValueChange,
  onRelativeUnitChange,
}) => {
  if (!requiresRelativeUnit) {
    return <div className="automation-rule-row-spacer" />;
  }

  if (requiresRelativeValue) {

    return (
      <div className="automation-modal-relative-group">
        <input
          className="automation-rule-input"
          style={{
            backgroundColor: theme.panel,
            borderColor: theme.backgroundMuted,
            color: theme.foreground,
          }}
          type="number"
          min="1"
          value={literalValue?.value ?? ''}
          onChange={(event) => onRelativeValueChange(event.target.value)}
        />

        <SelectInput
          style={{
            fontSize: '12px',
          }}
          value={normalizeRelativeUnit(literalValue?.unit) || 'days'}
          options={RELATIVE_DATE_UNITS}
          onChange={(event) => onRelativeUnitChange(event.target.value)}
        />
      </div>
    );
  }
  // ----- RENDER ----- //

  return (
    <SelectInput
      style={{
        fontSize: '12px',
      }}
      value={normalizeCalendarUnit(literalValue?.unit) || 'week'}
      options={RELATIVE_CALENDAR_UNITS}
      onChange={(event) => onRelativeUnitChange(event.target.value)}
    />
  );
});

// Dev Tools
RelativeDateValueEditor.displayName = 'RelativeDateValueEditor';

export default RelativeDateValueEditor;
